import React from "react";
import { useNavigate } from "react-router-dom";
import HomeLayout from "./ehealth/Layout";

const ErrorPage = ({ title }) => {
	const navigate = useNavigate();
	return (
		<HomeLayout>
			<div className="error-wrapper">
				<div className="error-content">
					<img
						src={require("../assets/img/undraw_fixing_bugs_w7gi.svg").default}
						alt="error image"
					/>
					<div className="text-content">
						<h1 className="title is-3 is-bold has-space">{title || "Page Not Found"}</h1>
						<p className="paragraph rem-125 stressed-1">
							Looks like we couldn't find the page you are requesting. Feel free
							to ask and open a support request.
						</p>
						<div className="buttons is-centered mt-4">
							<a
								href="/"
								onClick={(e) => {
									e.preventDefault();
									navigate(-1);
								}}
								className="button is-primary is-raised-hover mx-1"
							>
								Go Back
							</a>
						</div>
					</div>
				</div>
			</div>
		</HomeLayout>
	);
};

export default ErrorPage;
